// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k-layout-page-title[data-v-2cd816af]{padding:60px 0}@media screen and (max-width:959px){.k-layout-page-title[data-v-2cd816af]{padding:25px 0}}.k-layout-page-title--large[data-v-2cd816af]{padding:76px 0 65px}@media screen and (max-width:959px){.k-layout-page-title--large[data-v-2cd816af]{padding:39px 0 36px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
